import _sfc_main from "./RoomInfoPC.vue2.mjs";
/* empty css                 */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "conference-container" }, [_setup.isShowRoomInfoTitle ? _c("div", [_c("div", { staticClass: "title-container", on: { "click": function($event) {
    $event.stopPropagation();
    return _setup.toggleShowRoomInfoStatus.apply(null, arguments);
  } } }, [_c("span", { staticClass: "text" }, [_vm._v(_vm._s(_setup.conferenceTitle))]), _c(_setup.SvgIcon, { class: ["arrow-icon", { "arrow-down-icon": _setup.arrowDirection }], attrs: { "icon": _setup.Arrow } }), _c(_setup.RoomTime, { staticClass: "room-timing" })], 1)]) : _vm._e(), _setup.isShowRoomInfo ? _c("div", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: _setup.handleClickOutsideRoomInfoContainer, expression: "handleClickOutsideRoomInfoContainer" }], staticClass: "roomInfo-container" }, _vm._l(_setup.roomInfoTabList, function(item) {
    return _c("div", { directives: [{ name: "show", rawName: "v-show", value: item.visible, expression: "item.visible" }], key: item.id, staticClass: "roomInfo-content" }, [_c("span", { staticClass: "roomInfo-title" }, [_vm._v(_vm._s(_setup.t(item.title)))]), _c("span", { staticClass: "roomInfo-item" }, [_vm._v(_vm._s(item.content))]), item.isShowCopyIcon ? _c("div", { staticClass: "copy-container", on: { "click": function($event) {
      return _setup.onCopy(item.copyLink);
    } } }, [_c(_setup.SvgIcon, { staticClass: "copy", attrs: { "icon": _setup.copyIcon } }), _c("span", [_vm._v(_vm._s(_setup.t("Copy")))])], 1) : _vm._e()]);
  }), 0) : _vm._e()]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "566ab233"
);
const RoomInfoPc = __component__.exports;
export {
  RoomInfoPc as default
};
